import useSWR from 'swr';
import { useShopifyCartContext } from '@web/onboarding/OnboardingFlowContainer/ShopifyCartProvider';

const getPlanTypesUrl = (cartId, petId) => {
  if (!cartId || !petId) return null;
  return `api/v4/onboarding/${cartId}/pets/${petId}/plans/`;
};

export const useShopifyPlanTypes = (petId = '') => {
  const { cartId } = useShopifyCartContext();

  const {
    data: shopifyPlanTypes,
    isLoading,
    isValidating,
    error,
    mutate: mutatePlanTypes,
  } = useSWR(getPlanTypesUrl(cartId, petId));

  const planTypesMap = {};
  if (shopifyPlanTypes?.length) {
    shopifyPlanTypes.forEach(planType => {
      planTypesMap[planType.plan_type] = {
        ...planType,
      };
    });
  }

  return {
    planTypes: planTypesMap,
    isPlanTypesLoading: isLoading || isValidating,
    hasPlanTypesError: !!error,
    planTypesError: error,
    mutatePlanTypes,
  };
};
